import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot", "position", "badge", "upButton", "downButton"]

  connect() {
    this.submitTimer = null
    this.highlightTimer = null
    this.handleFrameLoad = this.handleFrameLoad.bind(this)
    document.addEventListener("turbo:frame-load", this.handleFrameLoad)
    this.refreshPositions()
    this.refreshControls()
  }

  disconnect() {
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
    }
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer)
    }
    document.removeEventListener("turbo:frame-load", this.handleFrameLoad)
  }

  autosubmit(event) {
    const form = event.target.closest("form")
    if (!form) return
    this.queueSubmit(form)
  }

  moveUp(event) {
    event.preventDefault()
    const button = event.currentTarget
    const slot = button.closest("[data-wizard-preview-target='slot']")
    if (!slot) return
    const slots = this.slotTargets
    const index = slots.indexOf(slot)
    if (index <= 0) return

    const reference = slots[index - 1]
    const parent = reference.parentNode
    if (parent) {
      parent.insertBefore(slot, reference)
    }
    this.afterReorder(slot)
  }

  moveDown(event) {
    event.preventDefault()
    const button = event.currentTarget
    const slot = button.closest("[data-wizard-preview-target='slot']")
    if (!slot) return
    const slots = this.slotTargets
    const index = slots.indexOf(slot)
    if (index === -1 || index >= slots.length - 1) return

    const reference = slots[index + 1]
    const parent = reference.parentNode
    if (parent) {
      if (reference.nextSibling) {
        parent.insertBefore(slot, reference.nextSibling)
      } else {
        parent.appendChild(slot)
      }
    }
    this.afterReorder(slot)
  }

  openSwap(_event) {
    const modal = document.getElementById("wizard-swap-modal")
    if (modal) {
      modal.dispatchEvent(new CustomEvent("open-modal"))
    }
  }

  handleFrameLoad(event) {
    if (event.target.id === "wizard_swap_modal") {
      const modal = document.getElementById("wizard-swap-modal")
      if (modal) {
        modal.dispatchEvent(new CustomEvent("open-modal"))
      }
    }
  }

  afterReorder(slot) {
    this.refreshPositions()
    this.refreshControls()
    const form = slot.closest("form")
    if (form) {
      this.queueSubmit(form)
    }
  }

  refreshPositions() {
    const slots = this.slotTargets
    const total = slots.length
    slots.forEach((slot, index) => {
      const prefix = `wizard[selected_lineup][${index}]`
      slot.dataset.index = index
      const badge = slot.querySelector("[data-wizard-preview-target='badge']")
      if (badge) {
        badge.textContent = `#${index + 1}`
      }
      const input = slot.querySelector("input[data-wizard-preview-target='position']")
      if (input) {
        input.value = index + 1
        input.setAttribute("max", total)
        input.name = `${prefix}[position]`
      }
      const hiddenFields = slot.querySelectorAll("[data-wizard-preview-field]")
      hiddenFields.forEach((field) => {
        const fieldKey = field.dataset.wizardPreviewField
        if (!fieldKey) return
        field.name = `${prefix}[${fieldKey}]`
      })
    })
  }

  refreshControls() {
    const slots = this.slotTargets
    const lastIndex = slots.length - 1
    slots.forEach((slot, index) => {
      const up = slot.querySelector("[data-wizard-preview-target='upButton']")
      const down = slot.querySelector("[data-wizard-preview-target='downButton']")
      if (up) {
        up.disabled = index === 0
      }
      if (down) {
        down.disabled = index === lastIndex
      }
    })
  }

  highlightSelection(event) {
    if (event) {
      event.preventDefault()
    }
    const target = document.getElementById("wizard-selected-list")
    if (!target) return
    target.scrollIntoView({ behavior: "smooth", block: "center" })
    target.classList.add("wizard-highlight")
    if (this.highlightTimer) {
      clearTimeout(this.highlightTimer)
    }
    this.highlightTimer = setTimeout(() => {
      target.classList.remove("wizard-highlight")
    }, 1200)
  }

  queueSubmit(form, delay = 120) {
    if (this.submitTimer) {
      clearTimeout(this.submitTimer)
    }

    this.submitTimer = setTimeout(() => {
      const autosubmitField = form.querySelector('input[name="autosubmit"]')
      if (autosubmitField) {
        autosubmitField.value = "1"
      }
      form.requestSubmit()
    }, delay)
  }
}
